import OrganizationDto from '@/common/classes/dto/OrganizationDto'
import { OrganizationSubjects } from '@/enums/OrganizationSubjects'
import { ApiClient } from '@/helpers/api-client/ApiClient'

let cachedSubjectId = null

export default class SubjectIdChanged {
  constructor(subject_id) {
    cachedSubjectId = subject_id
  }

  /**
   * @param {OrganizationDto} organization
   * @returns {Promise<OrganizationDto>}
   */
  trigger(organization) {
    cachedSubjectId = cachedSubjectId ?? organization.subject_id
    if (cachedSubjectId !== organization.subject_id) {
      cachedSubjectId = organization.subject_id
      let organizationPromise = Promise.resolve({
        nationality_id: organization.nationality_id,
        subject_id: organization.subject_id
      })
      if (organization.subject_id === OrganizationSubjects.Terminal) {
        organizationPromise = ApiClient
          .getTerminalOrganization()
          .then(response => new OrganizationDto({ ...response.data ?? organization, subject_id: OrganizationSubjects.Terminal }))
          .catch(() => organization)
      }
      organization = organizationPromise.then(organization => new OrganizationDto(organization))
    }

    return Promise.resolve(organization)
  }
}
